import { render } from "./WorkoutView.vue?vue&type=template&id=60fb913d"
import script from "./WorkoutView.vue?vue&type=script&lang=js"
export * from "./WorkoutView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__